import {AppStore, Constalation, DispatchThunkAny} from "../../types/redux";
import {ApiError, Tariffing} from "../../types/api";
import {fetchTariffingEpe} from "../../lib/services/mobivers/api";

import {log} from "../../utils/logger";
import {pick} from "../../lib/utils";

export const CONTRACT_PRICE_UPDATE = 'CONTRACT_PRICE_UPDATE';
export const CONTRACT_PRICE_KPP_UPDATE = 'CONTRACT_PRICE_KPP_UPDATE';
export const CONTRACT_PRICE_MOB_REFRESH = 'CONTRACT_PRICE_MOB_REFRESH';
export const CONTRACT_PRICE_MOB_REFRESH_DONE = 'CONTRACT_PRICE_MOB_REFRESH_DONE';
export const CONTRACT_PRICE_MOB_FAILED = 'CONTRACT_PRICE_MOB_FAILED';
export const CONTRACT_PRICE_MWD_REFRESH = 'CONTRACT_PRICE_MWD_REFRESH';
export const CONTRACT_PRICE_CALC = 'CONTRACT_CALC';
export const CONTRACT_PRICE_CALC_DONE = 'CONTRACT_CALC_DONE';
export const CONTRACT_PRICE_CALC_ERROR = 'CONTRACT_PRICE_CALC_ERROR'

export function contractPriceKppUpdate(
	key: number | string,
	price: number | false
): { type: string; payload: any } {
	return {
		type: CONTRACT_PRICE_KPP_UPDATE,
		payload: { key, price },
	};
}

export function calculateContract(): (
	dispatch: DispatchThunkAny,
	getState: any
) => Promise<Tariffing> {
	return async (dispatch: DispatchThunkAny, getState: any) => {
		try {
			const store: AppStore = { dispatch, getState };
			const { contract } = store.getState();
			dispatch({ type: CONTRACT_PRICE_CALC });
			const params: Constalation = pick(contract,  ['zahlweise', 'salesType', 'produkt']);
			const result: Tariffing = await fetchTariffingEpe(store, params);
			dispatch({ type: CONTRACT_PRICE_CALC_DONE, payload: result });
			return result;
		} catch (error) {
			log('Error while calculate contract', error);
			dispatch({ type: CONTRACT_PRICE_CALC_ERROR, payload: error, });
			return Promise.reject( (error as ApiError)?.error ?? 'Ein unbekannter Fehler ist aufgetreten.' );
		}
	};
}
